var map = {
	"./Home/Home.route.tsx": 400,
	"./Login/Login.route.tsx": 401,
	"./Privacy-policies/Privacy.route.tsx": 402,
	"./Profile/Profile.route.tsx": 403,
	"./Term-Of-Use/Term.route.tsx": 404
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 399;